import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            游戏分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大游戏品类，上千款精品游戏，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-50 border border-background-200 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              data-product-shop
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4 flex items-center gap-2">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                    <i className={`${cat.icon} text-white text-base`}></i>
                  </div>
                  <span className="text-white font-bold text-lg">{cat.name}</span>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-medium">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}